import { Outlet } from "react-router-dom";


const SaleBill = () => {
  return (<Outlet />)
}
export default SaleBill;
